<template>
  <div>
    <a target="_blank" :href="goods.detailUrl" class="mc-p-10">
      <el-image fit="contain" :src="goods.primaryPicUrl" style="width: 200px; height: 200px;"></el-image>
      <div class="mc-size20 red-text mc-bold">
        <span class="mc-size12">￥</span>
        {{goods.sellingPrice}}
      </div>
      <div class="mc-size12 mc-ellipsis2 mc-mt-10 mc-mb-20 goods-text">{{goods.productName}}</div>
      <div class="btn-option">
        <span @click.prevent="addCollect(goods.skuId)">收藏</span>
        <span @click.prevent="addCart(goods.skuId, goods.minPurchase)">加入购物车</span>
      </div>
    </a>
    <div class="add-cart" v-if="addCartDialog">
      <el-image :src="require('@/assets/images/add-cart.png')"></el-image>
      <div class="mc-size28 mc-mt-40">成功加入购物车</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["goods"],
  data() {
    return {
      addCartDialog: false,
    };
  },

  // components: {},

  // computed: {},

  // mounted: {},

  methods: {
    async addCart(id, num) {
      location.href = 'https://www.qx.com/Account/Login';
      // await this.$axios
      //   .post(this.$http.api + "/v1/cart/addcart", {
      //     skuId: id,
      //     quantity: num,
      //   })
      //   .then((res) => {
      //     if (!res.code) {
      //       this.addCartDialog = true;
      //       this.$store.dispatch("getCart");
      //       setTimeout(() => {
      //         this.addCartDialog = false;
      //       }, 1000);
      //     }
      //   });
    },
    async addCollect(id) {
      location.href = 'https://www.qx.com/Account/Login';
      // await this.$axios.post(this.$http.api + '/v1/cart/addfavorites', {skuId: id}).then(res => {
      //   if (!res.code) {
      //     this.$message({
      //       message: '加入收藏夹成功',
      //       type: 'success'
      //     });
      //   }
      // })
    },
  },
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
a {
  display: block;
  width: 200px;
  color: @gray3;
  .goods-text{
    height: 32px;
  }
  .btn-option {
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: flex;
    font-size: 12px;
    :first-child {
      width: 70px;
      display: block;
      background: @eee;
    }
    :last-child {
      width: 130px;
      border: 1px solid @ccc;
    }
  }
}
a:hover {
  box-shadow: 0 0 8px 0px rgba(162, 162, 162, 0.5);
}
.btn-option {
  :first-child:hover {
    color: @yellow;
  }
  :last-child:hover {
    color: @yellow;
    border-color: @yellow;
  }
}
.add-cart {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10001;
  background: @white;
  padding: 50px;
  border-radius: 10px;
  box-shadow: 0 0 15px 0 rgba(162, 162, 162, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/searchItem.vue